import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"timeout":_vm.timeout,"color":_vm.color},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c(VBtn,_vm._b({attrs:{"color":_vm.closeTextColor,"text":""},on:{"click":function($event){_vm.showSnackBar = false}}},'v-btn',attrs,false),[_vm._v("\n        Close\n        ")])]}}]),model:{value:(_vm.showSnackBar),callback:function ($$v) {_vm.showSnackBar=$$v},expression:"showSnackBar"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n\n    ")])
}
var staticRenderFns = []

export { render, staticRenderFns }